import React from "react";
import PropTypes from "prop-types";

const CardSlide = (props) => {
	const { title, description, button } = props;

	return (
		<div className="card">
			<h1 className="card__title">{title}</h1>
			{description && <p className="card__description">{description}</p>}
			{button && button.url && (
				<a
					className="button card__button"
					href={button.url}
				>
					{button.title}
				</a>
			)}
		</div>
	);
};
export default CardSlide;

CardSlide.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	button: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	onNext: PropTypes.func,
	onPrev: PropTypes.func,
};
